namespace HA.Core.HTML.TBox {
    export class SimpleListItem extends Div {
        protected createSelf() {
            super.createSelf();
            this.addClass("i");
        }
    }
}
